import { useState } from 'react';
import { useCarts, useCartsDispatch } from '../../contexts/CartContext';
import { XMarkIcon, ShoppingCartIcon,TrashIcon, PlusCircleIcon , MinusCircleIcon   } from '@heroicons/react/24/outline'
import { Link } from 'react-router';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

const apiurl = `${process.env.REACT_APP_API}/products.php`
const imgurl = `${process.env.REACT_APP_URL}/image/products`

function numberWithCommas (nStr) {
    nStr = nStr + '';
      let x = nStr.split('.');
      let x1 = x[0];
      let x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      x = x1 + x2;
      if(x.substr(0,1) === '.'){
          x = '0' + x;
      }
      return x + '฿';
  };
  
  function formatDateTime() {
    const now = new Date();
  
    const year = now.getFullYear(); // Get the year
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed, so add 1
    const day = String(now.getDate()).padStart(2, '0'); // Day of the month
  
    const hours = String(now.getHours()).padStart(2, '0'); // Hours
    const minutes = String(now.getMinutes()).padStart(2, '0'); // Minutes
    const seconds = String(now.getSeconds()).padStart(2, '0'); // Seconds
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  let shipping = 300;

const CheckoutForm = () => {
    let navigate = useNavigate();
    const cart = useCarts();
    const dispatch = useCartsDispatch();
    const [refId, setRefId] =useState(null);
    const [formData, setFormData] = useState({
        fullName: '',
        tel: '',
        email: '',
        address: '',
        district: '',
        city: '',
        state: '',
        zip: '',
    });
 
    useEffect(() => {
        setRefId(crypto.randomUUID().split("-", 1));
    },[])
      
    const [slipImage, setSlipImage] = useState(null);

    if(cart.length===0) localStorage.removeItem("cart");

    const cartItems = [
        { id: 1, name: 'Item 1', quantity: 2, price: 20 },
        { id: 2, name: 'Item 2', quantity: 1, price: 35 },
        { id: 3, name: 'Item 3', quantity: 3, price: 15 },
    ];

    const getFileSizeString = (bytes, decimals = 2) => {
        if (!+bytes) return '0 Bytes'
        const k = 1000
        const dm = decimals < 0 ? 0 : decimals
        const sizes  = ['Bytes', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];
        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
      }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        setSlipImage(e.target.files[0]);
        // console.log(e.target.files[0]);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const formDataToSubmit = new FormData();
        formDataToSubmit.append('refId', refId);
        formDataToSubmit.append('fullName', formData.fullName);
        formDataToSubmit.append('address', formData.address);
        formDataToSubmit.append('city', formData.city);
        formDataToSubmit.append('state', formData.state);
        formDataToSubmit.append('zip', formData.zip);
        formDataToSubmit.append('slipImage', slipImage);

        console.log('Form Data Submitted:', {
            ...formData,
            cartItems,
            slipImage: slipImage?.name || 'No file uploaded',
        });

        handleNext();
    };

    const handleNext = () => {
        dispatch({
          type: 'empty',
          });
    
        navigate("/shop#");
      }
    
    const calculateTotal = () => {
        return cart.reduce((total, item) => total + item.price * item.quantity, 0);
    };

    // console.log(cart);

    return (
        <div className="max-w-7xl mx-auto mt-4 p-4 rounded-lg shadow-md">
            <h2 className="text-2xl font-bold text-white text-center mb-2">การชำระเงิน</h2>
            <div className="flex flex-col p-2 rounded-lg md:flex-row-reverse gap-4 bg-slate-100">
                <div className="flex-1 p-2 rounded-lg bg-slate-200">
                    {/* Cart Details */}
                    <div className="mb-2">
                        <div className="flex justify-between font-semibold text-gray-900 border-b">
                            <h3>รายการสินค้า</h3>
                            <h3>เลขอ้างอิง: {refId}</h3>
                        </div>
                        <ul className="space-y-3 p-1">
                            {cart.map((product,item) => (
                                <li key={item} className="flex py-1">
                                    <div className="size-14 shrink-0 overflow-hidden rounded-md border border-gray-200">
                                        <img alt={product.imageSrc} src={`${imgurl}/${product.imageSrc}`} className="size-full object-cover" />
                                    </div>

                                    <div className="ml-2 flex flex-1 flex-col">
                                        <div>
                                        <div className="flex justify-between text-sm  font-normal text-gray-900">
                                            <h3>
                                            <a href={product.href}>{product.name}</a>
                                            </h3>
                                            <p className="font-medium ml-1">{product.price*product.quantity}฿</p>
                                        </div>
                                        {/* <p className="mt-1 text-sm text-gray-500">{product.color}</p> */}
                                        </div>
                                        <div className="flex flex-1 items-end justify-between text-sm">
                                        <div className="flex">
                                        <PlusCircleIcon  
                                            onClick={() => {
                                                    dispatch({
                                                    type: 'plus',
                                                    pdid: product.pdid,
                                                    price: product.price,
                                                    quantity: 1
                                                    });
                                                }}
                                            className="h-5  w-5 text-gray-500 hover:text-green-500 hover:cursor-pointer" 
                                            />                                
                                        <p className="px-2  text-sm font-medium text-gray-500">{product.quantity}</p>
                                        <MinusCircleIcon 
                                                onClick={() => {
                                                    dispatch({
                                                    type: 'minus',
                                                    pdid: product.pdid,
                                                    price: product.price,
                                                    quantity: 1
                                                    });
                                                }}
                                                className="h-5 w-5 text-gray-500 hover:text-red-500 hover:cursor-pointer" />
                                        </div>
                                        <div className="flex">
                                            <button type="button" 
                                            onClick={() => {
                                                dispatch({
                                                type: 'deleted',
                                                pdid: product.pdid
                                                });
                                            }}
                                                className="text-sm font-normal text-indigo-600 hover:text-indigo-500">
                                            <TrashIcon  className="h-5 w-5 text-gray-500 hover:text-red-500" />
                                            </button>
                                        </div>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                        <div className="mt-2 p-2 rounded-lg bg-slate-300 border">
                            <div className="flex justify-between font-normal text-gray-900">
                                <span>รวมค่าสินค้า:</span>
                                <span>{numberWithCommas(calculateTotal().toFixed(2))}</span>
                            </div>
                            <div className="flex justify-between font-normal text-gray-900">
                                <span>ค่าจัดส่ง:</span>
                                <span>{shipping}฿</span>
                            </div>
                            <div className="flex justify-between font-bold text-lg text-gray-900">
                                <span>รวม:</span>
                                <span>{numberWithCommas((calculateTotal() + shipping).toFixed(2))}</span>
                            </div>
                            
                        </div>

                        <div className="flex justify-between font-normal text-gray-900 gap-4 border mt-2 p-2 rounded-lg bg-slate-300">
                            <img src="/qrpayment.jpeg"
                                alt="QRScan"
                                className="object-cover mt-2 h-40 w-40 rounded-lg"
                            />
                            <div className="grid content-between">
                                <p className="mt-2  text-gray-600 text-wrap indent-4">*** กรุณาโอนเงิน <b> ${'420.00'} </b> เพื่อชำระค่าสินค้า โดยการสแกนคิวอาร์โค้ดด้านซ้ายนี้ แล้วทำการ <b>อัปโหลดสลิปการโอนเงิน</b> และกรอกข้อมูลการจัดส่งให้ครบถ้วน แล้วกดปุ่มบันทึก</p>
                                <p className="mt-2 text-sm font-semibold text-gray-600 text-wrap">สอบถามเพิ่มเติมได้ที่เบอร์ 035-559779.</p>
                                <Link 
                                    to="/shop" 
                                    className="rounded-md bg-sky-700 px-3 py-2 text-center text-sm font-normal text-white shadow-sm hover:bg-sky-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                    // onClick={handleAddnew}
                                >
                                    กลับไปหน้า ช๊อปปิ้ง...
                                </Link>
                            </div>
                        </div>
                    </div>
                
                </div>
            
                {/* Shipping Form */}
                <div  className="flex-1">
                    <label className="block text-md text-gray-700 font-semibold">*ที่อยู่สำหรับการจัดส่ง</label>
                    <form onSubmit={handleSubmit} className="space-y-2 mt-2">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">*ชื่อ - นามสกุล</label>
                            <input
                                type="text"
                                name="fullName"
                                value={formData.fullName}
                                onChange={handleChange}
                                required
                                className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">*ที่อยู่</label>
                            <input
                                type="text"
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                required
                                className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                            />
                        </div>
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">*เบอร์โทร</label>
                                <input
                                    type="text"
                                    name="tel"
                                    value={formData.tel}
                                    onChange={handleChange}
                                    required
                                    className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">E-Mail</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    // required
                                    className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">*ตำบล</label>
                                <input
                                    type="text"
                                    name="district"
                                    value={formData.district}
                                    onChange={handleChange}
                                    required
                                    className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">*อำเภอ</label>
                                <input
                                    type="text"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    required
                                    className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">*จังหวัด</label>
                                <input
                                    type="text"
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                    required
                                    className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">*รหัสไปรษณีย์</label>
                                <input
                                    type="number"
                                    name="zip"
                                    value={formData.zip}
                                    onChange={handleChange}
                                    required
                                    className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                        </div>

                        {/* Payment Slip Upload */}
                        <div>
                            <label className="block mt-4 text-sm text-gray-700 font-semibold">*อัปโหลดสลิปการโอนเงิน</label>
                            <input
                                id="file"
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                                required
                                className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                            />
                            {slipImage && (
                                <>
                                <p className="mt-2 text-sm text-gray-600">File size: {getFileSizeString(slipImage.size)}</p>
                                <img src={URL.createObjectURL(slipImage)} 
                                    alt="Slip"
                                    className="object-cover mt-2 h-28 w-28 border"
                                />
                                </>
                            )}
                        </div>
                        <button
                            type="submit"
                            disabled={cart.length>0 ? false : true}
                            className={cart.length>0 ? "w-full py-2 px-4 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" : "w-full py-2 px-4 bg-slate-600 text-white rounded-md cursor-not-allowed"}
                        >
                            บันทึก
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CheckoutForm;
